import React, { useState, useEffect } from "react";
import "./themeSwitch.css";

const ThemeSwitch = () => {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [darkMode]);
  return (
    <div class="dark:bg-[#101010]  bg-[#FAFAFA] flex justify-end py-[10px] px-[15px]">
      <div class="flex gap-[4px]">
        <div class="flex text-[11px] font-medium leading-[12px] flex-col text-end">
          <span class="text-grey">Appearance</span>
          <span class="text-foreground dark:text-white">{darkMode?"Dark Mode":"Light Mode"}</span>
        </div>
        <span class="text-muted">:</span>
        <label className="flex items-center cursor-pointer">
          {/* Hidden checkbox for the toggle switch */}
          <input
            type="checkbox"
            checked={darkMode}
            // onChange={() => setDarkMode(!darkMode)}
            className="hidden"
          />

          {/* The switch slider */}
          <div className="relative">
            <div
              className={`w-12 h-6 flex items-center rounded-full p-1 transition-all duration-300 ease-in-out ${
                darkMode ? "bg-blue-600" : "bg-gray-200"
              }`}
            >
              {/* Image based on the theme */}
              <img
                src={darkMode ? "/moon.png" : "/sun.png"}
                alt={darkMode ? "Dark Mode" : "Light Mode"}
                className={`w-4 h-4 absolute transition-all duration-300 ${
                  darkMode ? "bg-blue-600 left-1" : "bg-gray-200 left-7"
                }`}
              />
              <div
                className={`w-4 h-4 bg-white rounded-full shadow-md transform transition-all duration-300 ${
                  darkMode ? "translate-x-6" : "translate-x-0"
                }`}
              ></div>
            </div>
          </div>
        </label>
      </div>
    </div>
  );
};
export default ThemeSwitch;
